<template>
  <NuxtLayout>
    <div class="brandDetail__Content">
      <section class="brandDetail__Header">
        <h1 v-text="page.title" />
  
        <FlarePicture :src="{
            1920: { src: page.image, width: 1920, height: 960, size: 'both', crop: 'fill', requestLarger: false },
            1440: { src: page.image, width: 1440, height: 720, size: 'both', crop: 'fill', requestLarger: false },
            1024: { src: page.image_mobile || page.image, width: page.image_mobile ? 750 : 1024, height: page.image_mobile ? 1050 : 512, size: 'both', crop: 'fill', requestLarger: false }
          }"
          class="brandDetails__HeaderMainImage"
          :alt="page.image?.alt"
        />
        <Flare v-if="page.logo" class="brandDetails__HeaderLogo" :srcset="page.logo" width="380" :alt="page.logo" />
      </section>

      <CMSField v-if="page?.content" :data="page.content" />
    </div>
  </NuxtLayout>
</template>

<script setup>
  defineProps({
    page: {}
  });

  useHead({
    bodyAttrs: {
      class: 'transparentHeader brandDetail'
    }
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_brandDetail.scss');
</style>